import { useTranslation } from "react-i18next";

import { useIsMobile } from "~/shared/lib/use-media-query";
import { useChatUIStore } from "~/shared/store/useChatUIStore";
import { Sheet, SheetContent, SheetHeader, SheetTitle } from "~/shared/ui/sheet";

import { SettingsPanel } from "./SettingsPanel";

export function MobileSettingsSheet() {
    const { t } = useTranslation("chat-settings");
    const open = useChatUIStore((s) => s.settingsPanelOpen);
    const setOpen = useChatUIStore((s) => s.setSettingsPanelOpen);
    // Sheet виден ТОЛЬКО при `<md` (<768px). На md+ aside-панель уже отрисована
    // в ChatShellLayout (`md:flex`), и показывать sheet поверх неё — дубль.
    // Раньше тут был `useIsDesktop` (>=1280px), что давало gap 768-1279px
    // когда видны оба. Radix Sheet через portal сбегает из `md:hidden`-обёртки
    // в ChatShellLayout, поэтому ограничение делаем на уровне самого Sheet.
    const isMobile = useIsMobile();

    return (
        <Sheet open={isMobile && open} onOpenChange={setOpen}>
            {/* showCloseButton={false}: SettingsPanel уже рисует свой X
                в шапке (`showClose` пропс). Без этого видны два крестика
                один под другим в правом верхнем углу. */}
            {/* Цвета фона/радиус — в точности как в мокапе заказчика
                (`sntz_mockups/src/components/chat2/settings/MobileSettingsSheet.tsx`):
                плоский тёмный `bg-zinc-950` вместо shadcn-овского
                `bg-background` (он на нашей теме светло-серый), скруглённые
                верхние углы и тонкая разделительная линия сверху. */}
            <SheetContent
                side="bottom"
                showCloseButton={false}
                className="h-[85vh] rounded-t-2xl border-t border-white/10 bg-zinc-950 p-0"
            >
                <SheetHeader className="sr-only">
                    <SheetTitle>{t("title")}</SheetTitle>
                </SheetHeader>
                <SettingsPanel className="h-full w-full border-l-0" onClose={() => setOpen(false)} />
            </SheetContent>
        </Sheet>
    );
}
